import React, { useState, useEffect } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  HOME_PATH,
  MEDIAS_PATH,
  FAQ_PATH,
  SUPPLIER_PATH,
} from '../config/routes';
import MenusLight from '../components/MenusLight';
import { useResto } from '../contexts/RestoContext';
import { useIsWideScreen } from '../contexts/WebsiteContext';

const NavigationBar = () => {
    const { t } = useTranslation();
    const { restoData } = useResto();
    const isWideScreen = useIsWideScreen();
  

  return (
    <><Navbar className="navbar-dark-text background-main-color-80" style={{ paddingLeft: '10px'}}>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">

          <NavLink
            to={HOME_PATH}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('HOME')}
          </NavLink>

          <NavLink
            to={MEDIAS_PATH}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('PHOTO')}s
          </NavLink>

          <NavLink
            to={FAQ_PATH}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {t('FAQ')}
          </NavLink>

          {isWideScreen && (
              <NavLink
                to={SUPPLIER_PATH}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                {t('SUPPLIERS')}
              </NavLink>
            )}

        </Nav>
      </Navbar.Collapse>
    </Navbar>
    
    { restoData && restoData.hasNavigationMenu && <MenusLight />}
    </>
  );
};

export default NavigationBar;
